import React from 'react';
import { Copy, ThumbsUp, ThumbsDown, MapPin, Share } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks'
import { Message } from '../../types/chat';
import NiaLogo from '../NiaLogo/NiaLogo';
import UserAvatar from '../UserAvatar/UserAvatar';
import { Container, Avatar, Content, Text, Actions, ActionButton } from './styles';

interface ChatMessageProps {
  message: Message;
  showActions?: boolean;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, showActions = true }) => {
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const highlightOnMap = () => {
    // TODO: Implement map highlighting functionality
    console.log('Highlight on map functionality to be implemented');
  };

  const shareResponse = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Nia AI Response',
        text: message.content,
      });
    } else {
      copyToClipboard(message.content);
    }
  };

  return (
    <Container className={message.type} style={message?.id === 'welcome' ? {
      justifySelf: 'center'
    } : undefined}>
      <Avatar>
        {message.type === 'user' ? (
          <UserAvatar size={28} />
        ) : (
          <NiaLogo size={28} />
        )}
      </Avatar>
      <Content className={message.type}>
        <Text>
          {message.type === 'assistant' ? (
            <ReactMarkdown remarkPlugins={[remarkBreaks]}>{message.content?.replace(/\n/gi, "&nbsp; \n")}</ReactMarkdown>
          ) : (
            message.content
          )}
        </Text>
        {message.type === 'assistant' && showActions && (
          <Actions>
            <ActionButton
              onClick={() => copyToClipboard(message.content)}
              title="Copy response"
            >
              <Copy size={14} />
            </ActionButton>
            <ActionButton
              onClick={highlightOnMap}
              title="Highlight on map"
            >
              <MapPin size={14} />
            </ActionButton>
            <ActionButton
              onClick={shareResponse}
              title="Share response"
            >
              <Share size={14} />
            </ActionButton>
            <ActionButton title="Like response">
              <ThumbsUp size={14} />
            </ActionButton>
            <ActionButton title="Dislike response">
              <ThumbsDown size={14} />
            </ActionButton>
          </Actions>
        )}
      </Content>
    </Container>
  );
};

export default ChatMessage;
